module.exports = __webpack_public_path__ + "prosBottomCover.2264a58b5b0395b7ddd8.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/prosBottomCover.jpg
// module id = ../../../../../src/assets/coverPicks/prosBottomCover.jpg
// module chunks = 0